import { compose } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';
import Footer from './Footer';

const enhance = compose(
    connect(
        createStructuredSelector({
            activeStore: activeStoreSelector,
        }),
    ),
);

export default enhance(Footer);
